import { api } from "./api";

// Lightweight analytics event hook.
// Fires (a) Plausible if loaded, (b) backend log, (c) custom DOM event, (d) console.
export function track(name, props = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.plausible === "function") {
      window.plausible(name, { props });
    }
    api.postEvent(name, props);
    window.dispatchEvent(new CustomEvent("pt:event", { detail: { name, props } }));
    // eslint-disable-next-line no-console
    console.log("[analytics]", name, props);
  } catch (err) {
    // Analytics must NEVER break UX. Log at debug level only.
    // eslint-disable-next-line no-console
    console.debug("[analytics] event drop:", name, err?.message || err);
  }
}
